import { render, staticRenderFns } from "./CmgSustainabilityInfoCard.vue?vue&type=template&id=64aefba2&scoped=true&lang=pug&"
import script from "./cmg-sustainability-info-card.ts?vue&type=script&lang=ts&"
export * from "./cmg-sustainability-info-card.ts?vue&type=script&lang=ts&"
import style0 from "./CmgSustainabilityInfoCard.vue?vue&type=style&index=0&id=64aefba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aefba2",
  null
  
)

export default component.exports